import { Map, Record } from 'immutable';

export interface CategoryState extends Map<string, any> {
    createCategoriesLoading: boolean;
    createCategoriesData: any;
    createCategoriesFailData: any;

    getCategoriesListLoading: boolean;
    getCategoriesListData: any;
    getCategoriesListFailData: any;

    getCategoriesItemLoading: boolean;
    getCategoriesItemData: any;
    getCategoriesItemFailData: any;

    updateCategoriesItemLoading: boolean;
    updateCategoriesItemData: any;
    updateCategoriesItemFailData: any;

    deleteCategoriesItemLoading: boolean;
    deleteCategoriesItemData: any;
    deleteCategoriesItemFailData: any;

    createSliderItemLoading: boolean;
    createSliderItemData: any;
    createSliderItemFailData: any;

    getSliderItemLoading: boolean;
    getSliderItemData: any;
    getSliderItemFailData: any;

    getSliderListLoading: boolean;
    getSliderListData: any;
    getSliderListFailData: any;

    removeSliderItemLoading: boolean;
    removeSliderItemData: any;
    removeSliderItemFailData: any;

    updateSliderItemLoading: boolean;
    updateSliderItemData: any;
    updateSliderItemFailData: any;

    createPdfItemLoading: boolean;
    createPdfItemData: any;
    createPdfItemFailData: any;

    deletePdfItemLoading: boolean;
    deletePdfItemData: any;
    deletePdfItemFailData: any;

    updatePdfItemLoading: boolean;
    updatePdfItemData: any;
    updatePdfItemFailData: any;

    getPdfItemLoading: boolean;
    getPdfItemData: any;
    getPdfItemFailData: any;

    getPdfListLoading: boolean;
    getPdfListData: any;
    getPdfListFailData: any;
    getPdfListCount: number;

    createSliderLoading: boolean;
    createSliderData: any;
    createSliderFailData: any;

    updateSliderLoading: boolean;
    updateSliderData: any;
    updateSliderFailData: any;

    removeSliderLoading: boolean;
    removeSliderData: any;
    removeSliderFailData: any;

    getSliderLoading: boolean;
    getSliderData: any;
    getSliderFailData: any;

    getSlidersLoading: boolean;
    getSlidersData: any;
    getSlidersFailData: any;
}

export const CategoryRecord = Record({
    createCategoriesLoading: false,
    createCategoriesData: null,
    createCategoriesFailData: null,

    getCategoriesListLoading: false,
    getCategoriesListData: null,
    getCategoriesListFailData: null,

    getCategoriesItemLoading: false,
    getCategoriesItemData: null,
    getCategoriesItemFailData: null,

    updateCategoriesItemLoading: false,
    updateCategoriesItemData: null,
    updateCategoriesItemFailData: null,

    deleteCategoriesItemLoading: false,
    deleteCategoriesItemData: null,
    deleteCategoriesItemFailData: null,

    createSliderItemLoading: false,
    createSliderItemData: null,
    createSliderItemFailData: null,

    getSliderItemLoading: false,
    getSliderItemData: null,
    getSliderItemFailData: null,

    getSliderListLoading: false,
    getSliderListData: null,
    getSliderListFailData: null,

    removeSliderItemLoading: false,
    removeSliderItemData: null,
    removeSliderItemFailData: null,

    updateSliderItemLoading: false,
    updateSliderItemData: null,
    updateSliderItemFailData: null,

    createPdfItemLoading: false,
    createPdfItemData: null,
    createPdfItemFailData: null,

    deletePdfItemLoading: false,
    deletePdfItemData: null,
    deletePdfItemFailData: null,

    updatePdfItemLoading: false,
    updatePdfItemData: null,
    updatePdfItemFailData: null,

    getPdfItemLoading: false,
    getPdfItemData: null,
    getPdfItemFailData: null,

    getPdfListLoading: false,
    getPdfListData: null,
    getPdfListFailData: null,
    getPdfListCount: 0,

    createSliderLoading: false,
    createSliderData: null,
    createSliderFailData: null,

    updateSliderLoading: false,
    updateSliderData: null,
    updateSliderFailData: null,

    removeSliderLoading: false,
    removeSliderData: null,
    removeSliderFailData: null,

    getSliderLoading: false,
    getSliderData: null,
    getSliderFailData: null,

    getSlidersLoading: false,
    getSlidersData: null,
    getSlidersFailData: null,
})